<template>
  <div class="item-description-mail-slot-deliverable">
    <p class="item-description-mail-slot-deliverable-caption">
      ポスト投函でお届けします。
    </p>
  </div>
</template>

<script>
export default {
  name: 'ItemDescriptionMailSlotDeliverable'
}
</script>

<style lang="scss" scoped>
.item-description-mail-slot-deliverable {
  border-radius: 8px;
  background: $primary-lighten;
  padding: 8px 16px;
}

.item-description-mail-slot-deliverable-caption {
  @extend %caption;
  color: $brown-1;
}
</style>
